import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import milestoneService from '../../services/milestoneService';
import './MilestoneList.css';
import CommonModal from '../../services/CommonModal';
import { customDateFormatShort } from '../../config/utils';

const MilestoneList = () => {
  const [milestones, setMilestones] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedMilestone, setSelectedMilestone] = useState(null);
    const confirmDelete = () => {
    console.log("uuuu")
    handleDelete(selectedMilestone.id);
    setShowDeleteModal(false);
  };
  const navigate = useNavigate();

  useEffect(() => {
    fetchMilestones();
  }, []);

  const fetchMilestones = async () => {
    try {
      setLoading(true);
      const data = await milestoneService.getAllMilestones();
      setMilestones(data.data || []);
      setError(null);
    } catch (err) {
      setError('Failed to fetch milestones');
      console.error('Error fetching milestones:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    {
      try {
        await milestoneService.deleteMilestone(id);
        fetchMilestones();
      } catch (err) {
        alert('Failed to delete milestone');
        console.error('Error deleting milestone:', err);
      }
    }
  };

  const getStatusBadgeClass = (status) => {
    const statusMap = {
      'Not Started': 'badge-secondary',
      'In Progress': 'badge-primary',
      'Completed': 'badge-success',
      'On Hold': 'badge-warning',
      'Cancelled': 'badge-danger'
    };
    return statusMap[status] || 'badge-secondary';
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return customDateFormatShort(dateString);
  };

  if (loading) {
    return <div className="loading">Loading milestones...</div>;
  }

  const handleMilestoneClick = (id, isEdit) => {
    navigate(`/app/milestones/${id}/edit`);
    console.log("iddd",id,isEdit)
  };;


  return (
    <div className="milestone-list-container">
      <div className="milestone-list-header">
        <h2>Milestones</h2>
        <Link to="/app/milestones/new" className="btn btn-primary">
          <i className="fas fa-plus"></i> New Milestone
        </Link>
      </div>

      {error && <div className="alert alert-danger">{error}</div>}
                  <CommonModal
        isOpen={showDeleteModal}
        title="Delete Milestone"
        message="Are you sure you want to delete this milestone?"
        onClose={() => {
          setShowDeleteModal(false);
          setSelectedMilestone(null);
        }}
        onConfirm={confirmDelete}
        type="error"
        confirmText="Delete"
        cancelText="Cancel"
      />

      <div className="milestone-stats">
        <div className="stat-card">
          <h3>{milestones.length}</h3>
          <p>Total Milestones</p>
        </div>
        <div className="stat-card">
          <h3>{milestones.filter(m => m.status === 'Completed').length}</h3>
          <p>Completed</p>
        </div>
        <div className="stat-card">
          <h3>{milestones.filter(m => m.status === 'In Progress').length}</h3>
          <p>In Progress</p>
        </div>
        <div className="stat-card">
          <h3>{milestones.filter(m => m.status === 'Not Started').length}</h3>
          <p>Not Started</p>
        </div>
      </div>

      <div className="table-responsive">
        <table className="table milestone-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Project</th>
              <th>Status</th>
              <th>Due Date</th>
              <th>Completion Date</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {milestones.length === 0 ? (
              <tr>
                <td colSpan="6" className="text-center">
                  No milestones found. <Link to="/app/milestones/new">Create one</Link>
                </td>
              </tr>
            ) : (
              milestones.map((milestone) => (
                <tr key={milestone.id}>
                  <td>
                    <span
                      className="milestone-name cursor-pointer"
                      onClick={() => handleMilestoneClick(milestone.id,true)}
                    >
                      {milestone.name}
                    </span>
                  </td>
                  <td>
                    {milestone.project ? (
                      <Link to={`/app/projects/${milestone.project.id}/edit`}>
                        {milestone.project.name} ({milestone.project.code})
                      </Link>
                    ) : (
                      'N/A'
                    )}
                  </td>
                  <td>
                    <span className={`badge ${getStatusBadgeClass(milestone.status)}`}>
                      {milestone.status}
                    </span>
                  </td>
                  <td>{customDateFormatShort(milestone.due_date)}</td>
                  <td>{customDateFormatShort(milestone.completion_date)}</td>
                  <td>
                    <div className="flex gap-3">
                      <Link
                        to={`/app/milestones/${milestone.id}/edit`}
                        className="btn btn-sm btn-outline-primary custom-pbtn" 
                        title="Edit"
                      >
                        <i className="fas fa-edit custom-fas-icon"></i>
                      </Link>
                      <button
                        onClick={() => {
                          setSelectedMilestone(milestone);
                          setShowDeleteModal(true);
                        }}
                        className="btn btn-sm btn-outline-danger custom-dbtn"
                        title="Delete"
                      >
                        <i className="fas fa-trash"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default MilestoneList;


